<template>
      <v-card>
            <v-card-title class="d-flex justify-center">
                  {{ mode }}
            </v-card-title>
            <v-form @submit.prevent="submitForm" :key="formReset" ref="form" v-model="valid" class="px-4">
                  <v-alert dense v-if="error" color="red" elevation="5" outlined text type="error" align="center"
                        class="mr-1 ml-1 mb-5">
                        {{ alertValidate }}</v-alert>
                  <DateWithCheck :showCheck="true" class="mb-4"/>
                  <v-select required dense :rules="rules" label="Operadores disponibles" outlined v-model="data.employees"
                        :items="getOperators" item-value="id" :item-text="itemText" name="name" />
                  <div class="d-flex justify-space-between mx-2 pb-4" >
                        <v-btn class="bt-exit" @click="cancel">{{ $tc('editRegistrations.cancel') }}</v-btn>
                        <v-btn type="submit" class="bt-acept "> {{ $tc('editRegistrations.acept') }}</v-btn>
                  </div>

            </v-form>
      </v-card>
</template>
<script>
import DateWithCheck from '../../Complement/DateWithCheck.vue';
import date from '../../../store/common/date';
import delegations from '../../../store/workflow/delegations';

export default {
      components: { DateWithCheck },
      props: {
            formSubmitted: Boolean
      },

      data() {
            return {
                  mode: "Delegar operador",
                  inputsForm: [],
                  valid: true,
                  error: false,
                  alertValidate: "",
                  data:{
                        operators:""
                  },
                  selects: [],
                  formReset: false,
                  rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
            }
      },
      watch: {
            formSubmitted(newVal) {
                  if (newVal) {
                        this.cancel()
                        this.formReset = true;
                  }
            }
      },

      computed: {
            getOperators() {
                  return delegations.state.operators
            },
            itemText() {
            return function(item) {
                  return `${item.name} - ${item.level} (${item.nameLevel})`;
            };
            }

      },
      methods: {
            submitForm(e) {
                  e.preventDefault();
                  this.validation(e.target)
            },
            handleSubmit(form) {
                  const formData = new FormData(form);
                  let itemsComplete = {};
                  for (let [name, value] of formData) {
                        itemsComplete[name] = value;
                  }
                  this.$refs.form.resetValidation();

                  itemsComplete = {
                        ...itemsComplete,
                        from: date.state.dateFrom,
                        to: date.state.dateTo,
                        checkTo: date.state.checkTo
                  }
                  
                  this.$emit('save', itemsComplete);
            },
            cancel() {
                  const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10)
                  this.$refs.form.resetValidation();
                  this.$emit('cancel', this.data)
                  date.commit("setDateFrom", day);
                  date.commit("setDateTo", null);
            },
            validation(form) {
                  let valid = this.$refs.form.validate()
                  if (valid) {
                        this.handleSubmit(form);
                  } else {
                        this.error = true
                        this.alertValidate = this.$tc('editRegistrations.required dense')
                        setTimeout(() => {
                              this.error = false;
                        }, 2500);
                  }
            },
      
            showError(message) {
                  this.error = true;
                  this.alertValidate = message;
                  setTimeout(() => {
                        this.hideError();
                  }, 10000);
            },
            hideError() {
                  this.error = false;
                  this.alertValidate = "";

            },
            

      }
}

</script>
<style scoped>


.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}

.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
.container-buttons {
      display: flex;
      flex-direction: row;
      justify-content: center;
      padding: 5px;
}
</style>